import React from 'react';
import { useSelector } from 'react-redux';
import { infoDialogConfig } from '../../../Redux/InfoDialogSlice';
import InfoDialog from './InfoDialog';
import { GlobalDialogs } from '../../../pdf/GlobalDialogs';

/**
 * Component that shows a configurable information dialog.
 */
export default () => {
    const dialogConfig = useSelector(infoDialogConfig);

    if (dialogConfig === null) {
        return <></>;
    }

    return (
        <InfoDialog open={true} title={dialogConfig.title}>
            {GlobalDialogs.content}
        </InfoDialog>
    );
};
